import React from 'react';
import { object, string } from 'prop-types';

const MonitoringQueueEntryScoringDetailsTableRow = ({ entry, color }) => (
  <React.Fragment>
    <tr>
      <td>{entry.scoreCardRiskFactorName}</td>
      <td>{entry.clientParamValue}</td>
      <td className={color}>{entry.scoreCardRiskProfileName}</td>
    </tr>
  </React.Fragment>
);
MonitoringQueueEntryScoringDetailsTableRow.propTypes = {
  entry: object.isRequired,
  color: string,
};

export default MonitoringQueueEntryScoringDetailsTableRow;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/scoring-details-table/row/MonitoringQueueEntryScoringDetailsTableRow.jsx